/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-12 09:19:19
 * @LastEditTime: 2020-06-12 09:19:20
 * @LastEditors:
 */
export default {
  logLogin: {
    userName: 'User name',
    loginLime: 'Login time',
    logList: 'Log list',
    ipAddres: 'IP address',
    loginApplication: 'Login application',
    exitTime: 'Exit time',
    tenant: 'Tenant'
  }
};



// WEBPACK FOOTER //
// ./src/config/langs/en_US/logLogin.js